import service from '@/api/intl';
import {loading, handleError} from '@/state/generators/helpers';

export const state = {
    loading: false,
    item: {},
    service: service(),
    supportedLanguages: []
}

export const getters = {
    loading: (state) => {
        return state.loading
    },
    item: (state) => (key) => {
        return JSON.parse(JSON.stringify(state.item[key] || state.supportedLanguages.reduce((acc,curr)=> (acc[curr]='',acc),{}) || {}));
    },
    supportedLanguages: (state) => {
        return JSON.parse(JSON.stringify(state.supportedLanguages));
    }
}

export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean;
    },

    'SET_ITEM': function (state, obj = {}) {
        state.item = Object.assign({}, state.item, obj);
    },

    'SET_SUPPORTED_LANGUAGES': function (state, list = []) {
        state.supportedLanguages = list;
    }
}

export const actions = {
    supportedLanguages: function ({commit, state}) {
        loading(commit);

        return state.service.fetchSupportedLanguages().then(data => {
            commit('SET_SUPPORTED_LANGUAGES', data);
            loading(commit, false);
            return data;
        }).catch((e) => {
            handleError(e, commit);
        })
    },

    translationsOfKey: function ({commit, state}, key) {
        loading(commit);

        return state.service.fetchTranslationsOfKey({ translationKey: key }).then(data => {
            const item = {};
            item[key] = data;
            commit('SET_ITEM', item);
            loading(commit, false);
            return data;
        }).catch((e) => {
            handleError(e, commit);
        })
    },
}
